import { Box, HStack, VStack, Text, IconButton, Button } from '@chakra-ui/react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'

function toLocalDateStr(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function getWeekDates(weekStart: string): { dateStr: string; dayLabel: string; dayNum: string }[] {
  const start = new Date(weekStart + 'T00:00:00')
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return days.map((day, i) => {
    const d = new Date(start); d.setDate(d.getDate() + i)
    return { dateStr: toLocalDateStr(d), dayLabel: day, dayNum: `${months[d.getMonth()]} ${d.getDate()}` }
  })
}

interface DayChipSwitcherProps {
  weekStart: string
  selectedDate: string
  onSelectDate: (d: string) => void
  onPrevWeek: () => void
  onNextWeek: () => void
  onToday: () => void
}

export function DayChipSwitcher({ weekStart, selectedDate, onSelectDate, onPrevWeek, onNextWeek, onToday }: DayChipSwitcherProps) {
  const dates = getWeekDates(weekStart)
  const today = toLocalDateStr(new Date())
  return (
    <Box>
      <HStack justify="space-between" mb={2}>
        <IconButton
          aria-label="Previous week"
          size="sm"
          variant="ghost"
          minW="44px"
          h="44px"
          onClick={onPrevWeek}><FiChevronLeft /></IconButton>
        <Button size="sm" variant="outline" minH="44px" px={4} onClick={onToday}>Today</Button>
        <IconButton
          aria-label="Next week"
          size="sm"
          variant="ghost"
          minW="44px"
          h="44px"
          onClick={onNextWeek}><FiChevronRight /></IconButton>
      </HStack>
      <HStack gap={2} overflowX="auto" pb={1} css={{
        scrollbarWidth: 'none',
        '& ::-webkit-scrollbar': { display: 'none' }
      }}>
        {dates.map(({ dateStr, dayLabel, dayNum }) => {
          const isSelected = dateStr === selectedDate
          const isToday = dateStr === today
          return (
            <VStack
              key={dateStr}
              gap={0}
              minW="52px"
              h="56px"
              justify="center"
              borderRadius="lg"
              borderWidth="1px"
              borderColor={isSelected ? 'accent' : 'gray.200'}
              bg={isSelected ? 'accent' : isToday ? 'accent.soft' : 'white'}
              color={isSelected ? 'white' : 'gray.700'}
              flexShrink={0}
              asChild><button onClick={() => onSelectDate(dateStr)}>
                <Text fontSize="2xs" fontWeight="bold">{dayLabel}</Text>
                <Text fontSize="xs">{dayNum}</Text>
              </button></VStack>
          );
        })}
      </HStack>
    </Box>
  );
}
